var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPayPal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 24,
    viewBox: "0 0 39 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 38,
    height: 24,
    rx: 4,
    fill: "#E9E9E9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1244 17.9375H14.1557C13.6807 17.9375 13.2057 17.7 12.9088 17.3438C12.6119 16.9875 12.4932 16.5125 12.6119 16.0375L15.165 4.875C15.3432 4.1625 15.9369 3.6875 16.7088 3.6875H21.815C23.1807 3.6875 24.4275 4.28125 25.3182 5.35C26.1494 6.41875 26.5057 7.78437 26.2088 9.15C25.7338 11.525 23.5963 13.1875 21.1619 13.1875H19.2619C18.965 13.1875 18.6682 13.425 18.6088 13.7219L17.7182 17.4625C17.6588 17.7594 17.4213 17.9375 17.1244 17.9375Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1244 17.9375H14.1557C13.6807 17.9375 13.2057 17.7 12.9088 17.3438C12.6119 16.9875 12.4932 16.5125 12.6119 16.0375L15.165 4.875C15.3432 4.1625 15.9369 3.6875 16.7088 3.6875H21.815C23.1807 3.6875 24.4275 4.28125 25.3182 5.35C26.1494 6.41875 26.5057 7.78437 26.2088 9.15C25.7338 11.525 23.5963 13.1875 21.1619 13.1875H19.2619C18.965 13.1875 18.6682 13.425 18.6088 13.7219L17.7182 17.4625C17.6588 17.7594 17.4213 17.9375 17.1244 17.9375Z",
    fill: "#01308A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3969 9.20898C27.3969 9.26836 27.3969 9.32773 27.3969 9.38711C26.8031 12.2965 24.1906 14.3746 21.2219 14.3746H19.7375L18.9063 17.759C18.6688 18.5902 17.9563 19.1246 17.125 19.1246H15.9375C15.9969 19.3621 16.0563 19.5402 16.2344 19.7184C16.5313 20.0746 16.9469 20.2527 17.4219 20.2527H20.0938C20.3906 20.2527 20.6281 20.0746 20.6875 19.8371L21.5188 16.5715C21.5781 16.334 21.8156 16.2152 22.0531 16.2152H23.775C25.9719 16.2152 27.9313 14.7309 28.3469 12.6527C28.5844 11.4059 28.2281 10.0996 27.3969 9.20898Z",
    fill: "#019CDE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayPal);
export default __webpack_public_path__ + "static/media/PayPal.020f761d024c380a023f8e4485a4ac08.svg";
export { ForwardRef as ReactComponent };